import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=38d2e77b&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=38d2e77b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2e77b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d2e77b')) {
      api.createRecord('38d2e77b', component.options)
    } else {
      api.reload('38d2e77b', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=38d2e77b&scoped=true&", function () {
      api.rerender('38d2e77b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bRE5Hmmg3mpb/JS/comp/GuestBox.vue"
export default component.exports